export default __webpack_public_path__ + "static/media/minusOrange.05833bff.svg";